import React, { useEffect, useState } from "react";
import { fetchLookupItems } from "../Services/fetchLookupItems";

/**
 * Generic Single Select Dropdown Component
 * ---------------------------------------
 * Props:
 * - tableName
 * - idColumn
 * - nameColumn
 * - value
 * - onChange
 */
const SingleSelectDropdown = ({
    tableName,
    idColumn,
    nameColumn,
    value,
    onChange,
    placeholder = "--Select option--"
}) => {
    const [items, setItems] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        loadItems();
    }, [search]);

    const loadItems = async () => {
        const data = await fetchLookupItems({
            tableName,
            idColumn,
            nameColumn,
            searchText: search,
            type: "single"
        });
        setItems(data);
    };

    return (
        <div className="dropdown-container">
            {/* Search box */}
            {/*<input*/}
            {/*    type="text"*/}
            {/*    placeholder="Search..."*/}
            {/*    value={search}*/}
            {/*    onChange={e => setSearch(e.target.value)}*/}
            {/*    className="dropdown-search"*/}
            {/*/>*/}

            {/* Dropdown */}
            <select
                value={value || ""}
                onChange={e => onChange(e.target.value)}
                className="dropdown-select"
            >
                <option value="">{placeholder}</option>

                {items.map(item => (
                    <option key={item.id} value={item.id}>
                        {item.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SingleSelectDropdown;
